import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
  VideoURL: {
    id: 'Video URL',
    defaultMessage: 'Video URL',
  },
  VideoURLHint: {
    id: 'mpf_video_block_url_hint',
    defaultMessage:
      'Endereço de um vídeo, live ou playlist do YouTube. O portal não hospeda arquivos de vídeo: publique no canal do MPF no YouTube e cole o link aqui.',
  },
  Preview_image: {
    id: 'Preview Image URL',
    defaultMessage: 'Imagem de capa',
  },
  PreviewImageHint: {
    id: 'mpf_video_block_preview_image_hint',
    defaultMessage:
      'Aparece antes de o vídeo começar. Em branco, o YouTube e o Vimeo entregam a capa do próprio vídeo.',
  },
  Alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  caption: {
    id: 'mpf_video_block_caption',
    defaultMessage: 'Legenda',
  },
  captionHint: {
    id: 'mpf_video_block_caption_hint',
    defaultMessage:
      'Texto exibido abaixo do vídeo. Deixe em branco para não exibir legenda.',
  },
  formato: {
    id: 'mpf_video_block_formato',
    defaultMessage: 'Formato',
  },
  formatoHint: {
    id: 'mpf_video_block_formato_hint',
    defaultMessage:
      'Vertical (9:16) para vídeos de celular, no estilo Reels/Shorts. O player fica estreito e centralizado.',
  },
  formatoPadrao: {
    id: 'mpf_video_block_formato_padrao',
    defaultMessage: 'Padrão (16:9)',
  },
  formatoVertical: {
    id: 'mpf_video_block_formato_vertical',
    defaultMessage: 'Vertical (9:16)',
  },
});

/** Valores do campo `formato`. */
export const VIDEO_FORMATO_PADRAO = 'padrao';
export const VIDEO_FORMATO_VERTICAL = 'vertical';
export const VideoBlockSchema = (props) => ({
  title: props.intl.formatMessage(messages.Video),
  block: 'Video',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['url', 'caption', 'preview_image', 'formato', 'align'],
    },
  ],

  properties: {
    url: {
      title: props.intl.formatMessage(messages.VideoURL),
      // A descrição é o que resta para "vídeo local": o campo continua sendo
      // uma URL em texto (é o contrato que o `Body.jsx` do core espera — um
      // `object_browser` gravaria um array e quebraria o player), então o
      // caminho do arquivo interno precisa ser colado à mão.
      description: props.intl.formatMessage(messages.VideoURLHint),
      widget: 'url',
    },
    // O core não tem legenda; o design da sub-home pede uma, no mesmo desenho
    // do bloco Imagem — ver a customização de `Video/View.jsx`.
    caption: {
      title: props.intl.formatMessage(messages.caption),
      description: props.intl.formatMessage(messages.captionHint),
      widget: 'textarea',
    },
    // `image` (e não o `url` do core): o campo é a CAPA do player, e com um
    // campo de texto livre é fácil colar por engano o endereço de uma página
    // — foi o que aconteceu em produção, e o `Body.jsx` do core dá prioridade
    // absoluta a ele, então o player ficava cinza com a thumbnail do YouTube
    // disponível e sem uso. O widget `image` navega pelo site, aceita
    // arrastar arquivo e grava string, que é o que o `Body.jsx` espera.
    preview_image: {
      title: props.intl.formatMessage(messages.Preview_image),
      description: props.intl.formatMessage(messages.PreviewImageHint),
      widget: 'image',
    },
    // Vídeo de celular (Reels/Shorts/TikTok) num player 16:9 fica com duas
    // tarjas pretas ocupando a maior parte da largura. Este campo troca a
    // proporção e estreita o player — ver `components/_image-block.scss`.
    formato: {
      title: props.intl.formatMessage(messages.formato),
      description: props.intl.formatMessage(messages.formatoHint),
      choices: [
        [
          VIDEO_FORMATO_PADRAO,
          props.intl.formatMessage(messages.formatoPadrao),
        ],
        [
          VIDEO_FORMATO_VERTICAL,
          props.intl.formatMessage(messages.formatoVertical),
        ],
      ],
      default: VIDEO_FORMATO_PADRAO,
    },
    align: {
      title: props.intl.formatMessage(messages.Alignment),
      widget: 'align',
      // RNF02: mesma restrição do bloco Imagem — sem float/wrap no corpo de
      // texto, então `left`/`right` saem das opções (ver
      // `customizations/volto/components/manage/Blocks/Image/schema.jsx`).
      actions: ['center', 'full'],
    },
  },
  required: [],
});

export default VideoBlockSchema;
